import React from 'react';
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import MuiTable from "../common/MuiTable";
import {
    exportReport
} from "../../util/ApiUtils";
import {NotificationManager, NotificationContainer} from "react-notifications";
import {Spinner} from "../common/Spinner";
import {
    addAuditPlanRevision,
    audit,
    auditPlan,
    auditPlanRevision,
    deleteAuditPlan, saveOrUpdateAudit,
    saveOrUpdateAuditPlan
} from "../../util/AuditPlanApiUtils";
import {BlueButton, GreenButton, GreyButton} from "../common/ButtonsConstants";
import {AddCircleOutlineTwoTone} from "@material-ui/icons";
import moment from "moment";
import CardHeader from "@material-ui/core/CardHeader";
import Modal from "@material-ui/core/Modal";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import TextField from "@material-ui/core/TextField";
import SignaturePad from "react-signature-canvas";
import CommonRevisionModal from "../common/CommonRevisionModal";
import Typography from "@material-ui/core/Typography";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    {
        title: 'id',
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    {
        title: 'Audit title',
        field: 'title',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: 'Audit criteria and scope of the audit',
        field: 'criteria',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: 'Date audit to be conducted',
        field: 'date',
        type: "date",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: 'Auditors allocated to conduct the audit',
        field: 'auditorsAllocated',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: 'Audit results are to be reported to relevant management',
        field: 'results',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    }
];

class AuditPlan extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            auditPlan: [],
            isLoading: true,
        };
        this.loadAuditPlan = this.loadAuditPlan.bind(this);
        this.handleSaveOrUpdate = this.handleSaveOrUpdate.bind(this);
        this.handleSaveOrUpdateAudit = this.handleSaveOrUpdateAudit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.isValid = this.isValid.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onFooterEdit = this.onFooterEdit.bind(this);
        this.onFooterSave = this.onFooterSave.bind(this);
        this.clear = this.clear.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.onSignatureEnd = this.onSignatureEnd.bind(this);
        this.addRevision = this.addRevision.bind(this);
    }

    sigPad = {};

    clear = () => {
        this.sigPad.clear()
    };

    addRevision(request) {
        addAuditPlanRevision(request)
            .then(response => {
                NotificationManager.success('Success', 'The Revision has been updated.', 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    onDateChange(event, date) {
        console.log(event); //null
        console.log('date', date); //whatever the date the user picked
        this.setState({
            ...this.state, date: moment(date, "DD/MM/YYYY"),
        });
    }

    handleTextChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    componentDidMount() {
        this.loadAuditPlan(() => auditPlanRevision()
            .then(response => {
                console.log('Revision');
                console.log(response);
                this.setState({
                    latestRevision: response,
                    isLoading: false,
                    isEditing: false,
                });
            })
            .catch(error => {
                console.log(error);
            })
        )
    }

    loadAuditPlan(callback) {
        audit()
            .then(response => {
                console.log(response);
                this.setState({
                    id: response.id,
                    directorName: response.directorName,
                    signature: response.signature,
                    date: response.date,
                });
                auditPlan()
                    .then(response => {
                        console.log(response);
                        this.setState({
                            auditPlan: response
                        });
                        if (callback) {
                            callback();
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleSaveOrUpdateAudit(request) {
        console.log(request);
        saveOrUpdateAudit(request)
            .then((updatedObj) => {
                console.log("updated audit id " + updatedObj.id);
                console.log("updated audit " + updatedObj);
                console.log(this.state);
                NotificationManager.success('Success', 'The Audit Plan has been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    handleSaveOrUpdate(request) {
        console.log(request);
        saveOrUpdateAuditPlan(request)
            .then((updatedObj) => {
                console.log("updated audit plan id " + updatedObj.id);
                console.log("updated audit plan " + updatedObj);
                console.log(this.state);
                this.loadAuditPlan();
                NotificationManager.success('Success', 'The Audit Plan has been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    handleDelete(request) {
        console.log(request);
        deleteAuditPlan(request)
            .then(() => {
                this.loadAuditPlan();
                NotificationManager.success('Success', 'The Audit Plan has been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    isValid(newData) {
        let isValid = newData.title && newData.title !== '';
        if (!isValid) {
            NotificationManager.error('Error', 'Validation Error. Title is required', 5000);
        }
        return isValid;
    }

    onFooterEdit() {
        this.setState({
            isEditing: true
        });
    }

    onFooterSave() {
        this.setState({
            isEditing: false
        }, () => {
            this.handleSaveOrUpdateAudit({
                id: this.state.id,
                signature: this.state.signature,
                date: this.state.date,
                directorName: this.state.directorName,
            });
        });
    }

    onSignatureEnd(value) {
        this.setState({
            signature: value
        });
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }
        const isRevision = (state.latestRevision.id !== null);
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
                <Typography component="h2" variant="h5">
                    AUDIT PLAN
                </Typography>
                <CardHeader
                    action={
                        <BlueButton
                            variant="contained"
                            color="secondary"
                            startIcon={<AddCircleOutlineTwoTone/>}
                            onClick={this.showModal}
                            size="small"
                            style={{marginRight: '10px'}}
                            disabled={isAuditor}
                        >
                            ADD
                        </BlueButton>
                    }
                    title={
                        <span style={{color: "darkblue"}}>
                            <p><b>{isRevision && `Revision ${state.latestRevision.number} Author: ${state.latestRevision.author}`}</b></p>
                            <p><b>Approved for suitability and adequacy by: {state.latestRevision.approvedBy} on {moment(state.latestRevision.date).format('DD/MM/YYYY')}</b></p>
                        </span>
                    }
                />
                <Paper className={classes.root} style={{ marginTop: '30px' }}>
                    <MuiTable
                        title={''}
                        columns={columns}
                        data={state.auditPlan}
                        onAdd={this.handleSaveOrUpdate}
                        onUpdate={this.handleSaveOrUpdate}
                        onDelete={this.handleDelete}
                        exportButton={!isDemo}
                        onExport={() => exportReport('/audit-plan/export')}
                        isValid={this.isValid}
                        pageSize={10}
                        allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                    />
                </Paper>
                {
                    state.isEditing ?
                        <div style={{ marginTop: "30px" }}>
                            <div style={{ width: "400px", height: "360px", paddingTop: "30px" }}>
                                <label>
                                    Please sign below by using your mouse or touchpad:
                                </label>
                                <div style={{ clear: "both", borderStyle: "ridge", borderWidth: "1px", padding: "0px", display: "table-cell" }}>
                                    <SignaturePad
                                        canvasProps={{ width: "400px", height: "300px" }}
                                        onEnd={() => { console.log('onEnd called'); this.onSignatureEnd(this.sigPad.toDataURL('image/png')); }}
                                        ref={(ref) => {
                                            this.sigPad = ref;
                                            if (state.signature && this.sigPad) {
                                                this.sigPad.fromDataURL(state.signature, { width: 400, height: 300})
                                            }
                                        }}
                                    />
                                    <GreyButton onClick={this.clear}>
                                        CLEAR
                                    </GreyButton>
                                </div>
                            </div>
                            <div style={{ paddingTop: "60px" }}>
                                <TextField
                                    id="directorName"
                                    name="directorName"
                                    value={state.directorName}
                                    label="Name of Managing Director or equivalent"
                                    onChange={this.handleTextChange}
                                    style={{ width: "300px"}}
                                />
                            </div>
                            <div style={{ paddingTop: "30px" }}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        disableToolbar
                                        autoOk
                                        variant="inline"
                                        format="DD/MM/YYYY"
                                        margin="normal"
                                        id="date"
                                        label="Date"
                                        name="date"
                                        value={state.date}
                                        onChange={ this.onDateChange }
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: "300px"}}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                            <div style={{ paddingTop: "30px" }}>
                                <GreenButton
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<AddCircleOutlineTwoTone/>}
                                    onClick={this.onFooterSave}
                                    size="small"
                                    style={{marginRight: '10px'}}
                                >
                                    SAVE
                                </GreenButton>
                            </div>
                        </div>
                        :
                        <div style={{ marginTop: "30px" }}>
                            <div>{ state.signature ? <img src={ state.signature }/> : <span style={{ color: 'yellow', background: 'grey'}}>&lt;Insert signature of Managing Director or equivalent&gt;</span>}</div>
                            <div style={{ paddingTop: "30px" }}>{ state.directorName ? state.directorName : <span style={{ color: 'yellow', background: 'grey'}}>&lt;Name of Managing Director or equivalent&gt;</span>}</div>
                            <div style={{ paddingTop: "30px" }}>{ state.date ? moment(state.date).format('DD/MM/YYYY') : <span style={{ color: 'yellow', background: 'grey'}}>&lt;Date&gt;</span>}</div>
                            <div style={{ paddingTop: "30px" }}>
                                <BlueButton
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<AddCircleOutlineTwoTone/>}
                                    onClick={this.onFooterEdit}
                                    size="small"
                                    style={{marginRight: '10px'}}
                                    disabled={isAuditor}
                                >
                                    EDIT
                                </BlueButton>
                            </div>
                        </div>
                }
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={state.show}
                    onClose={() => this.closeModal(null)}
                >
                    <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
                </Modal>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(AuditPlan);